import angular from 'angular';

angular.module('folkeuni').filter('sum', function() {
  return function(input, property) {
    var result = 0;

    for(var i in input){
      if(property !== 'undefined') {
        result += input[i][property];
      } else {
        result += input[i];
      }
    }

    return result;
  }
});
